const Home = () => {
  return (
    <>
      <h2>Home page!</h2>
      <h2>
        <a href="/admin/dashboard">access dashboard!</a>
      </h2>
    </>
  );
};

export default Home;
